import { memo } from 'react';

import Image from 'next/image';
import styled, { useTheme } from 'styled-components';

import Accordion from '@components/Accordion/next/Accordion';
import { useDevice } from '@contexts/device';
import Typography from '@components/Typography';

import { EntityFilter } from '../FiltersBlock';

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 5px;
  input[type='radio']:not(old):checked {
    background-image: radial-gradient(
      circle at center,
      ${(p) => p.theme.palette.BR300},
      ${(p) => p.theme.palette.BR300} 37.5%,
      ${(p) => p.theme.palette.white} 50%,
      ${(p) => p.theme.palette.white} 100%
    );
  }
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 0px 20px;
  }
`;
export const RadioButton = styled.input`
  width: 15px;
  height: 15px;
  background-color: ${({ theme }) => theme.palette.transparent2};
  appearance: none;
  border-radius: 50%;
  border: 2px solid ${({ theme }) => theme.palette.NL800};
`;
export interface NameFilterProps {
  title?: string;
  point?: EntityFilter[];
  handleSelectedItems?: (item: string) => void;
  selectedItems?: string | string[];
}

const ReviewFilter = ({
  title,
  point,
  handleSelectedItems,
  selectedItems,
}: NameFilterProps) => {
  const { isDesktop } = useDevice();
  const { palette } = useTheme();

  return (
    <>
      <Accordion
        label={title}
        headerContentColor='eclipse'
        alwaysShowBottomBorder={false}
        headerPadding={isDesktop ? '0px' : '15px'}
        mobileLabelFontSize='16px'
        iconSize={16}
        iconColor='NL800'
        contentPadding='0px'
        labelFontSize='16px'
        accordionTitleStyles={{
          color: palette.NL800,
        }}
      >
        {point?.[0]?.items
          ?.slice(0)
          ?.reverse()
          ?.map((i) => (
            <div key={i.key}>
              {parseInt(i.key) !== 0 && parseInt(i.key) !== 1 ? (
                <CheckboxContainer>
                  <RadioButton
                    onChange={() => handleSelectedItems?.(i.key)}
                    type='radio'
                    name='discount'
                    checked={selectedItems == i.key}
                  />
                  <Image
                    width={70}
                    height={40}
                    src={i.value}
                    alt='appstoreqr'
                  />
                  <Typography
                    variant='caption2'
                    color='NL800'
                    weight='SemiBold'
                  >
                    {parseInt(i.key) !== 5 ? `${i.key} ve üzeri` : '5'}
                  </Typography>
                </CheckboxContainer>
              ) : null}
            </div>
          ))}
      </Accordion>
    </>
  );
};

export default memo(ReviewFilter);
